import ImageSlider from '../components/image_slider';

class ProductPage {

  constructor(containerId = null) {
    this.containerNode = containerId ? document.getElementById(containerId) : null;

    if (!this.containerNode) {
      return;
    }

    this.init()
  }

  init() {
    this.setUpImageSlider()
  }

  setUpImageSlider() {
    this.imageSlider = new ImageSlider()
  }
}

export default ProductPage;